export function getLanguageType() {
  let locale = '';
  try {
    locale = window.localStorage.getItem('OMC.locale');
  } catch (e) {
    locale = Cookies.get('OMC.locale');
  }
  return locale;
}

export function setLanguageType(code) {
  try {
    window.localStorage.setItem('OMC.locale', code);
  } catch (e) {
    Cookies.set('OMC.locale', code, {
      expires: new Date(~(1 << 31) * 1e3),
      path: process.env.MOUNT_BASE.slice(0, -1),
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils.js